import PropTypes from 'prop-types';
import React from 'react';
import clientConfig from 'universal-config';
import { readLocalStorage } from 'redux/saga/helpers/local-storage';

let spScriptRendered = false;
const SNOWPLOW_ENABLED = __CLIENT__ || __TEST__;

const SP_INIT_JS = `(function(p,l,o,w,i,n,g){if(!p[i]||!p[i].track){p.GlobalSnowplowNamespace=p.GlobalSnowplowNamespace||[];
  p.GlobalSnowplowNamespace.push(i);if(!p[i]){p[i]=function(){(p[i].q=p[i].q||[]).push(arguments)}};
  p[i].q=p[i].q||[];n=l.createElement(o);g=l.getElementsByTagName(o)[0];n.async=1;n.src=w;
  g.parentNode.insertBefore(n,g)}}(window,document,"script","//d1fc8wv8zag5ca.cloudfront.net/2.6.1/sp.js","snowplow"));`;

const TRACKER = clientConfig().snowplow.tracker;

export const trackUnstruct = (name, data = {}) => {
  if (SNOWPLOW_ENABLED) {
    if (__CLIENT__ && readLocalStorage('trackingDebug')) {
      console.info('Tracking snowplow', name, data); // eslint-disable-line no-console
    }

    if (!window.snowplow) {
      window.snowplow = (...args) => (window.snowplow.q = window.snowplow.q || []).push(args);
    }

    window.snowplow(`trackUnstructEvent:${TRACKER}`, {
      schema: 'iglu:com.classpass/general_event/jsonschema/1-0-0',
      data: {
        event_type: name,
        event_data: JSON.stringify(data || {}),
      },
    });
  }
};

export class SnowplowTracker extends React.Component {
  componentDidMount() {
    const { host, appId } = this.props;

    if (spScriptRendered && !__TEST__) {
      return;
    }
    spScriptRendered = true;

    const sdkInitJs = `snowplow('newTracker', '${TRACKER}', '${host}', {
      appId: '${appId}',
      platform: 'web',
      bufferSize: 1,
      encodeBase64: true,
      forceSecureTracker: true,
      post: false
    });`;

    const script = document.createElement('script');
    script.textContent = SP_INIT_JS + sdkInitJs;
    script.id = 'sp-js-root';
    document.body.appendChild(script);
  }

  render() {
    return false;
  }
}

SnowplowTracker.propTypes = {
  host: PropTypes.string.isRequired,
  appId: PropTypes.string.isRequired,
};
